
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { getBilingualValue } from '@/utils/bilingual-helpers';

interface PractitionerAboutProps {
  bio?: string | null;
  bioEn?: string | null;
  bioZh?: string | null;
}

const PractitionerAbout: React.FC<PractitionerAboutProps> = ({ bio, bioEn, bioZh }) => {
  const { t, i18n } = useTranslation('practitioners');

  const displayBio = getBilingualValue(i18n.language, bioEn, bioZh, bio);

  if (!displayBio) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('about')}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-earth-700 leading-relaxed">{displayBio}</p>
      </CardContent>
    </Card>
  );
};

export default PractitionerAbout;
